(function () {

  'use strict';



  function pad(n) {

    return n < 10 ? '0' + n : String(n);

  }



  function initTimer(el) {

    var endStr = el.getAttribute('data-end-date');

    if (!endStr) return;



    var endTime = new Date(endStr).getTime();

    if (isNaN(endTime)) return;



    var daysEl = el.querySelector('[data-ct-days]');

    var hoursEl = el.querySelector('[data-ct-hours]');

    var minsEl = el.querySelector('[data-ct-minutes]');

    var secsEl = el.querySelector('[data-ct-seconds]');



    if (!daysEl || !hoursEl || !minsEl || !secsEl) return;



    function update() {

      var now = Date.now();

      var diff = endTime - now;



      if (diff <= 0) {

        clearInterval(interval);

        onExpiry(el);

        return;

      }



      var totalSec = Math.floor(diff / 1000);

      var days = Math.floor(totalSec / 86400);

      var hours = Math.floor((totalSec % 86400) / 3600);

      var mins = Math.floor((totalSec % 3600) / 60);

      var secs = totalSec % 60;



      daysEl.textContent = pad(days);

      hoursEl.textContent = pad(hours);

      minsEl.textContent = pad(mins);

      secsEl.textContent = pad(secs);

    }



    // Run immediately, then every second

    update();

    var interval = setInterval(update, 1000);

  }



  function onExpiry(el) {

    var action = el.getAttribute('data-expiry-action') || 'hide';



    if (action === 'hide') {

      el.style.display = 'none';

    } else if (action === 'redirect') {

      var url = el.getAttribute('data-expiry-redirect');

      if (url) window.location.href = url;

    } else if (action === 'show_message') {

      // Hide timer + content, show expiry message

      var timer = el.querySelector('.c-countdown-timer__timer');

      var content = el.querySelector('.c-countdown-timer__content');

      var cta = el.querySelector('.c-countdown-timer__cta-wrap');

      var msg = el.querySelector('[data-ct-expiry-msg]');



      if (timer) timer.style.display = 'none';

      if (content) content.style.display = 'none';

      if (cta) cta.style.display = 'none';

      if (msg) msg.style.display = '';

    }

  }



  function init() {

    var timers = document.querySelectorAll('[data-countdown-timer]');

    for (var i = 0; i < timers.length; i++) {

      initTimer(timers[i]);

    }

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', init);

  } else {

    init();

  }



  // Re-init on Shopify section events (theme editor)

  document.addEventListener('shopify:section:load', function (e) {

    var section = e.target;

    var timers = section.querySelectorAll('[data-countdown-timer]');

    for (var i = 0; i < timers.length; i++) {

      initTimer(timers[i]);

    }

  });

})();

